import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Modal.css';

const Modal = ({ isOpen, closeModal, selectedTimeSlot, setReservationDetails }) => {
  const navigate = useNavigate();

  if (!isOpen) return null;

  const { time, type, date } = selectedTimeSlot;

  const handleSelect = () => {
    setReservationDetails(selectedTimeSlot);
    localStorage.setItem('pierchicReservation', JSON.stringify(selectedTimeSlot));
    navigate('/reservation');
  };

  return (
    <div className="modal-overlay" onClick={closeModal}>
      <div className="modal-container" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <div className="modal-title">PIERCHIC</div>
          <button className="modal-close" onClick={closeModal}>&times;</button>
        </div>
        <div className="modal-content">
          <div className="modal-date">{date} • {time}</div>
          
          <div className="modal-section">
            <div className="modal-section-title">About</div>
            <p className="modal-paragraph">A mesmerizing lunch experience by the sea elevated by traditional yet refined Italian dishes</p>
            <p className="modal-paragraph">Perfect for mid-day relaxation with loved ones or a quick escape from the busy city</p>
            <p className="modal-paragraph">Expertly crafted menu by Chef Beatrice Segoni</p>
            <p className="modal-paragraph">Perched on the resort's iconic pier with panoramic vistas</p>
            <p className="modal-paragraph">Available on Monday - Friday, from 13:00 to 14:30</p>
            <p className="modal-paragraph">AED 140 per person including a two-course set menu</p>
          </div>
        </div>
        <div className="modal-footer">
          <button className="modal-select-button" onClick={handleSelect}>Select</button>
        </div>
      </div>
    </div>
  );
};

export default Modal; 